import PhotonLogo from "../Common/PhotonLogo";
import AppearanceControls from "../Common/AppearanceControls";
import Footer from "./Footer";

const AuthPageLayout = ({ children }) => {
  return (
    <div className="photon-standalone-page min-h-screen flex flex-col bg-surface-page px-4 sm:px-0">
      <header className="flex justify-end py-4 sm:px-6">
        <AppearanceControls />
      </header>
      <main className="flex flex-1 flex-col items-center pt-8 sm:pt-[8vh] pb-8 gap-6">
        <div>
          <PhotonLogo wordmark className="h-[60px] w-[270px] text-[42px]" />
        </div>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default AuthPageLayout;
